<template>
  <div class="info">
    <Hero
      class="hero"
      :startpage="true"
      heading="The SeenThis Brand"
      :heroRightSideImage="'our-brand-computor.png'"
      :heroLeftSideImage="'our-brand-mobile.png'"
      :noBackgroundImage="true"
      :heroOverlay="'displayNone'"
    />
    <div class="introTextContainer">
      <p class="introText">
        Our brand platform is very simple and there's a reason for
        that - we want to be able to use it. Today we set the direction,
        tomorrow we expand.
      </p>
      <br/>
      <p class="introText">The SeenThis brand consists of the following building blocks:</p>
    </div>
    <TabBar :tabs="['Brand Core', 'Vision & Mission', 'Tone of Voice']" v-model="tab"/>
    <div class="tab-content">
      <div class="brand-core" v-if="tab === 0">
        <ListInfoItem label="Our core" title="Seen this!?">
          In everything we do, we want to show it. This is how we sell,
          how we play and how we collaborate. We call this our core because
          it is the epicenter of screen life. Have you seen this?!
        </ListInfoItem>
        <ListInfoItem label="Character" title="Exciting, relevant and human.">
          By always being EXCITING, RELEVANT and HUMAN, we can share the
          astonishing things that we have innovated, improved and made more efficient.
        </ListInfoItem>
        <ListInfoItem label="Arena" title="Technology and marketing tech.">
          We live our life in technology. Right now, we fight wars in marketing
          tech and we always act on a global level.
          <div class="arena"><img src="../assets/arena.svg"></div>
        </ListInfoItem>
      </div>
      <div class="vision" v-if="tab === 1">
        <ListInfoItem
          label="Vision"
          title="Create a fast internet with a smart footprint"
        />
        <ListInfoItem
          label="Mission"
          title="Set future internet standards by innovating content delivery"
        />
      </div>
      <div class="tone-of-voice" v-if="tab === 2">
        <p>
          In everything we say and write, we want to convey SeenThis as a positive,
          efficient and reliable company. Never unnecessarily complicated or
          corporate; <strong>always relatable, playful and dedicated.</strong> We love what we do
          and we love to help our clients. These messages should be obvious in all
          of our communication!
        </p>
        <p>
          Since we operate on the international stage, we use the English
          language (American spelling). <strong>We like to use energetic and
          positive wording.</strong> For instance, we use the word ”fast” when we talk
          about our technology, since, you know, it is!
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Hero from '../components/hero.vue';
import TabBar from '../components/tab-bar.vue';
import ListInfoItem from '../components/list-info-item.vue';

export default {
  name: 'Info',
  data() {
    return {
      tab: 0,
    };
  },
  components: {
    Hero,
    TabBar,
    ListInfoItem,
  },
};
</script>


<style lang="stylus" scoped>
  @require '../style/colors'
  .introTextContainer
    text-align: center
    margin: 70px 0 100px 0

  .introText
    display: inline-block
    max-width: 600px
    margin: 12px
    line-height: 1.6
    font-size: 18px
    font-weight: 300

  .tab-content
    background-color: $green30
    padding: 0 2rem

  .tab-content
    display: flex
    justify-content: center
    & > *
      max-width: 1000px

  .arena
    margin-top: 6rem
    max-width: 50rem

    @media only screen and (max-width: 600px)
      padding-left: 2rem
      margin: 6rem auto 0 auto

  .tone-of-voice
    padding: 5rem 0
    max-width: 55rem

    p
      font-size: 18px
      font-family: space-grotesk

</style>
